




















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "bill/phone";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "时间", dataIndex: "created_time" },
    { title: "用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "订场类型", scopedSlots: { customRender: "type" } },
    { title: "场馆", dataIndex: "stadium_name" }
  ];

  mounted() {
    this.loadData();
  }
}
